import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logosConveio from '../../assets/Logo_Prosperidad_Social.png';

// ─── Colores ──────────────────────────────────────────────────────────────────
const C = {
  primary:   "#1a5276",
  light:     "#2e86c1",
  accent:    "#e67e22",
  white:     "#ffffff",
  text:      "#1c2833",
  muted:     "#7f8c8d",
  border:    "#d5d8dc",
  bg:        "#f4f6f8",
  bgBlue:    "#eaf3fb",
  success:   "#1e8449",
  successBg: "#eafaf1",
  rowAlt:    "#f0f6fc",
  tableHead: "#1a5276",
};

// ─── Estilos ──────────────────────────────────────────────────────────────────
const S = StyleSheet.create({
  page: {
    fontFamily:      "Helvetica",
    backgroundColor: C.white,
    paddingBottom:   30,
    paddingTop:      0,
    paddingHorizontal: 0,
    fontSize:        8,
    color:           C.text,
  },

  // ── CABECERA ──
  header: {
    flexDirection:   "row",
    backgroundColor: C.primary,
    minHeight:       72,
  },
  headerLogo: {
    width:           90,
    backgroundColor: C.white,
    alignItems:      "center",
    justifyContent:  "center",
    padding:         8,
  },
  headerLogoPlaceholder: {
    width:           74,
    height:          50,
    backgroundColor: "#e8edf2",
    borderRadius:    4,
    alignItems:      "center",
    justifyContent:  "center",
  },
  headerLogoText: {
    fontSize:  7,
    color:     C.muted,
    textAlign: "center",
  },
  headerCenter: {
    flex:            1,
    paddingHorizontal: 16,
    paddingVertical: 10,
    justifyContent:  "center",
  },
  headerTitle: {
    color:       C.white,
    fontSize:    13,
    fontFamily:  "Helvetica-Bold",
    marginBottom: 3,
    letterSpacing: 0.3,
  },
  headerSubtitle: {
    color:    "#d6eaf8",
    fontSize: 8,
  },
  headerRight: {
    width:           110,
    backgroundColor: C.light,
    paddingHorizontal: 10,
    paddingVertical: 10,
    justifyContent:  "center",
    alignItems:      "flex-end",
  },
  headerRightLabel: {
    color:      "#d6eaf8",
    fontSize:   7,
    marginBottom: 2,
  },
  headerRightValue: {
    color:      C.white,
    fontSize:   8,
    fontFamily: "Helvetica-Bold",
    textAlign:  "right",
  },

  // ── CUERPO ──
  body: {
    paddingHorizontal: 28,
    paddingTop:        8,
  },

  // ── SECCIÓN TÍTULO ──
  sectionRow: {
    flexDirection:   "row",
    alignItems:      "center",
    marginBottom:    5,
    marginTop:       6,
  },
  sectionBar: {
    width:           3,
    height:          13,
    backgroundColor: C.accent,
    borderRadius:    2,
    marginRight:     6,
  },
  sectionTitle: {
    fontSize:    8,
    fontFamily:  "Helvetica-Bold",
    color:       C.primary,
    letterSpacing: 0.8,
    textTransform: "uppercase",
  },

  // ── DATOS BENEFICIARIO ──
  benefGrid: {
    flexDirection: "row",
    flexWrap:      "wrap",
    backgroundColor: C.bgBlue,
    borderRadius:  4,
    padding:       8,
    marginBottom:  6,
    borderLeftWidth: 3,
    borderLeftColor: C.light,
    borderLeftStyle: "solid",
  },
  benefItem: {
    width:        "33.33%",
    paddingRight: 8,
    marginBottom: 6,
  },
  benefItemHalf: {
    width:        "50%",
    paddingRight: 8,
    marginBottom: 6,
  },
  benefItemFull: {
    width:        "100%",
    marginBottom: 6,
  },
  benefLabel: {
    fontSize:      6.5,
    color:         C.muted,
    fontFamily:    "Helvetica-Bold",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom:  2,
  },
  benefValue: {
    fontSize:   8.5,
    color:      C.text,
    fontFamily: "Helvetica-Bold",
    borderBottomWidth: 1,
    borderBottomColor: C.border,
    borderBottomStyle: "solid",
    paddingBottom: 3,
  },
  benefValueHighlight: {
    fontSize:   10,
    color:      C.primary,
    fontFamily: "Helvetica-Bold",
    borderBottomWidth: 1.5,
    borderBottomColor: C.light,
    borderBottomStyle: "solid",
    paddingBottom: 3,
  },

  // ── TABLA PRODUCTOS ──
  tableWrapper: {
    marginBottom: 8,
    borderRadius: 4,
    overflow:     "hidden",
    borderWidth:  1,
    borderColor:  C.border,
    borderStyle:  "solid",
  },
  tableHead: {
    flexDirection:   "row",
    backgroundColor: C.tableHead,
    paddingVertical: 5,
    paddingHorizontal: 6,
  },
  tableHeadCell: {
    color:      C.white,
    fontSize:   6.5,
    fontFamily: "Helvetica-Bold",
    textAlign:  "center",
    textTransform: "uppercase",
    letterSpacing: 0.3,
  },
  tableRow: {
    flexDirection:    "row",
    paddingVertical:  4,
    paddingHorizontal: 6,
    borderBottomWidth: 1,
    borderBottomColor: C.border,
    borderBottomStyle: "solid",
  },
  tableRowAlt: {
    backgroundColor: C.rowAlt,
  },
  tableRowLast: {
    borderBottomWidth: 0,
  },
  tableCell: {
    fontSize:  7.5,
    color:     C.text,
    textAlign: "center",
  },
  tableCellLeft: {
    fontSize:  7.5,
    color:     C.text,
    textAlign: "left",
  },
  tableTotalRow: {
    flexDirection:   "row",
    paddingVertical: 5,
    paddingHorizontal: 6,
    backgroundColor: C.primary,
  },
  tableTotalCell: {
    color:      C.white,
    fontSize:   7.5,
    fontFamily: "Helvetica-Bold",
    textAlign:  "center",
  },
  tableTotalCellLeft: {
    color:      C.white,
    fontSize:   7.5,
    fontFamily: "Helvetica-Bold",
    textAlign:  "left",
  },

  // ── CONSTANCIA DE ENTREGA ──
  entregaBox: {
    backgroundColor: "#eaf3fb",
    borderLeftWidth: 3,
    borderLeftColor: "#2e86c1",
    borderLeftStyle: "solid",
    borderRadius:    4,
    padding:         9,
    marginBottom:    8,
    marginTop:       4,
  },
  entregaTitle: {
    fontSize:      7,
    fontFamily:    "Helvetica-Bold",
    color:         "#2e86c1",
    textTransform: "uppercase",
    letterSpacing: 0.8,
    marginBottom:  4,
  },
  entregaText: {
    fontSize:   7.5,
    color:      "#1c2833",
    lineHeight: 1.65,
    textAlign:  "justify",
  },

  // ── CONSTANCIA DE RECEPCIÓN ──
  constanciaBox: {
    backgroundColor: C.successBg,
    borderWidth:     1,
    borderColor:     C.success,
    borderStyle:     "solid",
    borderRadius:    4,
    padding:         8,
    marginBottom:    6,
    marginTop:       4,
  },
  constanciaTitle: {
    fontSize:      7,
    fontFamily:    "Helvetica-Bold",
    color:         C.success,
    textTransform: "uppercase",
    letterSpacing: 0.8,
    marginBottom:  4,
  },
  constanciaText: {
    fontSize:   8,
    color:      C.text,
    lineHeight: 1.6,
    textAlign:  "justify",
  },

  // ── FIRMAS ──
  firmasRow: {
    flexDirection:  "row",
    justifyContent: "space-between",
    marginTop:      6,
    paddingHorizontal: 10,
  },
  firmaBox: {
    width:      "44%",
    alignItems: "center",
  },
  firmaLinea: {
    height:           30,
    borderBottomWidth: 1,
    borderBottomColor: C.text,
    borderBottomStyle: "solid",
    width:            "100%",
    marginBottom:     5,
  },
  firmaLabel: {
    fontSize:   7.5,
    color:      C.text,
    fontFamily: "Helvetica-Bold",
    textAlign:  "center",
  },
  firmaSub: {
    fontSize:  7,
    color:     C.muted,
    textAlign: "center",
    marginTop: 2,
  },

  // ── FOOTER ──
  footer: {
    position:   "absolute",
    bottom:     12,
    left:       28,
    right:      28,
    flexDirection:   "row",
    justifyContent:  "space-between",
    alignItems:      "center",
    borderTopWidth:  1,
    borderTopColor:  C.border,
    borderTopStyle:  "solid",
    paddingTop:      5,
  },
  footerText: {
    fontSize: 6.5,
    color:    C.muted,
  },
  footerPage: {
    fontSize: 6.5,
    color:    C.primary,
    fontFamily: "Helvetica-Bold",
  },
});

// ─── Anchos de columnas (deben sumar flex total) ──────────────────────────────
const COL = {
  alimento:   { flex: 3  },
  unidad:     { flex: 1.4 },
  pesoGramos: { flex: 1.4 },
  cantidad:   { flex: 1.4 },
  pesoTotal:  { flex: 1.4 },
};

// ─── Productos fijos (13 ítems) ───────────────────────────────────────────────
// Puedes sobreescribir esto pasando participante.productos si vienen del backend
const PRODUCTOS_DEFAULT = [
  { alimento: "Arroz blanco",        unidad: "Kilogramo",  pesoGramos: 1000, cantidad: 5,  pesoTotal: 5000 },
  { alimento: "Frijol rojo",         unidad: "Kilogramo",  pesoGramos: 1000, cantidad: 2,  pesoTotal: 2000 },
  { alimento: "Lenteja",             unidad: "Kilogramo",  pesoGramos: 500,  cantidad: 2,  pesoTotal: 1000 },
  { alimento: "Aceite vegetal",      unidad: "Litro",      pesoGramos: 900,  cantidad: 2,  pesoTotal: 1800 },
  { alimento: "Azúcar blanca",       unidad: "Kilogramo",  pesoGramos: 1000, cantidad: 2,  pesoTotal: 2000 },
  { alimento: "Sal refinada",        unidad: "Kilogramo",  pesoGramos: 500,  cantidad: 1,  pesoTotal: 500  },
  { alimento: "Harina de maíz",      unidad: "Kilogramo",  pesoGramos: 1000, cantidad: 2,  pesoTotal: 2000 },
  { alimento: "Pasta alimenticia",   unidad: "Gramos",     pesoGramos: 500,  cantidad: 4,  pesoTotal: 2000 },
  { alimento: "Avena en hojuelas",   unidad: "Gramos",     pesoGramos: 500,  cantidad: 2,  pesoTotal: 1000 },
  { alimento: "Atún en lata",        unidad: "Gramos",     pesoGramos: 160,  cantidad: 6,  pesoTotal: 960  },
  { alimento: "Sardinas en lata",    unidad: "Gramos",     pesoGramos: 170,  cantidad: 4,  pesoTotal: 680  },
  { alimento: "Leche en polvo",      unidad: "Gramos",     pesoGramos: 400,  cantidad: 2,  pesoTotal: 800  },
  { alimento: "Chocolate de mesa",   unidad: "Gramos",     pesoGramos: 250,  cantidad: 2,  pesoTotal: 500  },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
const getFecha = () =>
  new Date().toLocaleDateString("es-CO", { day: "2-digit", month: "long", year: "numeric" });

const numFmt = (n) =>
  Number(n).toLocaleString("es-CO");

// ─── Documento ────────────────────────────────────────────────────────────────
const ActaPDF = ({ participante }) => {
  const fecha    = getFecha();
  const productos = (participante.productos?.length ? participante.productos : PRODUCTOS_DEFAULT);
  const pesoTotalGeneral = productos.reduce((acc, p) => acc + Number(p.pesoTotal || 0), 0);

  return (
    <Document
      title={`Acta de Entrega - ${participante.nombre_completo}`}
      author="Prosperidad Social"
      subject="Estrategia Hambre Cero - Acta de Entrega"
    >
      <Page size="A4" style={S.page}>

        {/* ══ CABECERA ══════════════════════════════════════════════════════ */}
        <View style={S.header}>
          {/* Logo */}
          <View style={S.headerLogo}>
            <Image src={logosConveio} style={{ width: 74, height: 50, objectFit: "contain" }} />
          </View>

          {/* Título */}
          <View style={S.headerCenter}>
            <Text style={S.headerTitle}>Acta de Entrega de Paquete Alimentario</Text>
            <Text style={S.headerSubtitle}>
              Estrategia Hambre Cero · Prosperidad Social · Plan Nacional de Desarrollo 2022-2026
            </Text>
          </View>

          {/* Fecha y registro */}
          <View style={S.headerRight}>
            <Text style={S.headerRightLabel}>Fecha de entrega</Text>
            <Text style={S.headerRightValue}>{fecha}</Text>
            <Text style={[S.headerRightLabel, { marginTop: 6 }]}>N° Registro</Text>
            <Text style={S.headerRightValue}>{participante.id_registro}</Text>
          </View>
        </View>

        {/* ══ CUERPO ════════════════════════════════════════════════════════ */}
        <View style={S.body}>

          {/* ── 1. Datos del beneficiario ── */}
          <View style={S.sectionRow}>
            <View style={S.sectionBar} />
            <Text style={S.sectionTitle}>Datos del Beneficiario</Text>
          </View>

          <View style={S.benefGrid}>
            <View style={S.benefItemFull}>
              <Text style={S.benefLabel}>Nombre completo</Text>
              <Text style={S.benefValueHighlight}>{participante.nombre_completo}</Text>
            </View>
            <View style={S.benefItem}>
              <Text style={S.benefLabel}>Tipo de documento</Text>
              <Text style={S.benefValue}>{participante.tipo_documento}</Text>
            </View>
            <View style={S.benefItem}>
              <Text style={S.benefLabel}>N° Identificación</Text>
              <Text style={S.benefValue}>{participante.num_identificacion}</Text>
            </View>
            <View style={S.benefItem}>
              <Text style={S.benefLabel}>N° Registro</Text>
              <Text style={S.benefValue}>{participante.id_registro}</Text>
            </View>
            <View style={S.benefItemHalf}>
              <Text style={S.benefLabel}>Municipio</Text>
              <Text style={S.benefValue}>{participante.municipio}</Text>
            </View>
            <View style={S.benefItemHalf}>
              <Text style={S.benefLabel}>Departamento</Text>
              <Text style={S.benefValue}>{participante.departamento}</Text>
            </View>
          </View>

          {/* ── 2. Constancia de Entrega ── */}
          <View style={S.sectionRow}>
            <View style={S.sectionBar} />
            <Text style={S.sectionTitle}>Constancia de Entrega</Text>
          </View>

          <View style={S.entregaBox}>
            <Text style={S.entregaText}>
              {"Por medio de la presente acta, se hace constar que en el marco de la "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Estrategia Hambre Cero</Text>
              {" del Departamento Administrativo para la Prosperidad Social, se hace entrega de los siguientes productos alimentarios a: "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.nombre_completo}</Text>
              {", identificado(a) con "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.tipo_documento}</Text>
              {" N° "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.num_identificacion}</Text>
              {", residente en el municipio de "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.municipio}</Text>
              {", departamento de "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.departamento}</Text>
              {", en el marco del proyecto "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>
                "Implementación de la estrategia Hambre CERO para apoyar la accesibilidad a los
                alimentos de población en situación de pobreza, extrema pobreza y vulnerabilidad
                - FIP Nacional"
              </Text>
              {", durante el año 2025."}
            </Text>
          </View>

          {/* ── 3. Tabla de productos ── */}
          <View style={S.sectionRow}>
            <View style={S.sectionBar} />
            <Text style={S.sectionTitle}>Productos Alimentarios Entregados</Text>
          </View>

          <View style={S.tableWrapper}>
            {/* Encabezado */}
            <View style={S.tableHead}>
              <Text style={[S.tableHeadCell, COL.alimento]}>Alimento</Text>
              <Text style={[S.tableHeadCell, COL.unidad]}>Unidad de{"\n"}Medida</Text>
              <Text style={[S.tableHeadCell, COL.pesoGramos]}>Peso{"\n"}(gramos)</Text>
              <Text style={[S.tableHeadCell, COL.cantidad]}>Cantidad{"\n"}Entregada</Text>
              <Text style={[S.tableHeadCell, COL.pesoTotal]}>Peso Total{"\n"}(gramos)</Text>
            </View>

            {/* Filas */}
            {productos.map((prod, i) => (
              <View
                key={i}
                style={[
                  S.tableRow,
                  i % 2 === 1 && S.tableRowAlt,
                  i === productos.length - 1 && S.tableRowLast,
                ]}
              >
                <Text style={[S.tableCellLeft, COL.alimento]}>{prod.alimento}</Text>
                <Text style={[S.tableCell,     COL.unidad]}>{prod.unidad}</Text>
                <Text style={[S.tableCell,     COL.pesoGramos]}>{numFmt(prod.pesoGramos)}</Text>
                <Text style={[S.tableCell,     COL.cantidad]}>{prod.cantidad}</Text>
                <Text style={[S.tableCell,     COL.pesoTotal]}>{numFmt(prod.pesoTotal)}</Text>
              </View>
            ))}

            {/* Fila de totales */}
            <View style={S.tableTotalRow}>
              <Text style={[S.tableTotalCellLeft, COL.alimento]}>
                TOTAL · {productos.length} productos
              </Text>
              <Text style={[S.tableTotalCell, COL.unidad]}>—</Text>
              <Text style={[S.tableTotalCell, COL.pesoGramos]}>—</Text>
              <Text style={[S.tableTotalCell, COL.cantidad]}>
                {productos.reduce((a, p) => a + Number(p.cantidad || 0), 0)}
              </Text>
              <Text style={[S.tableTotalCell, COL.pesoTotal]}>
                {numFmt(pesoTotalGeneral)} g
              </Text>
            </View>
          </View>

          {/* ── 4. Constancia de recepción ── */}
          <View style={S.constanciaBox}>
            <Text style={S.constanciaTitle}>Constancia de Recepción Conforme</Text>
            <Text style={S.constanciaText}>
              Yo,{" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.nombre_completo}</Text>
              {", "}identificado(a) con {participante.tipo_documento} N°{" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.num_identificacion}</Text>
              {", "}residente en el municipio de{" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.municipio}</Text>
              {", "}departamento de{" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>{participante.departamento}</Text>
              {", "}declaro haber recibido a entera satisfacción los productos alimentarios
              relacionados en la presente acta, en el marco de la{" "}
              <Text style={{ fontFamily: "Helvetica-Bold" }}>Estrategia Hambre Cero</Text>
              {" "}del Departamento Administrativo para la Prosperidad Social.
            </Text>
          </View>

          {/* ── 5. Firmas ── */}
          <View style={S.firmasRow}>
            <View style={S.firmaBox}>
              <View style={S.firmaLinea} />
              <Text style={S.firmaLabel}>{participante.nombre_completo}</Text>
              <Text style={S.firmaSub}>{participante.tipo_documento} {participante.num_identificacion}</Text>
              <Text style={S.firmaSub}>Beneficiario(a)</Text>
            </View>
            <View style={S.firmaBox}>
              <View style={S.firmaLinea} />
              <Text style={S.firmaLabel}>Responsable de la Entrega</Text>
              <Text style={S.firmaSub}>Prosperidad Social</Text>
              <Text style={S.firmaSub}>Firma, nombre y cédula</Text>
            </View>
          </View>

        </View>

        {/* ══ FOOTER ════════════════════════════════════════════════════════ */}
        <View style={S.footer} fixed>
          <Text style={S.footerText}>Prosperidad Social · Estrategia Hambre Cero · {fecha}</Text>
          <Text style={S.footerPage}>
            Documento generado automáticamente · {participante.num_identificacion}
          </Text>
        </View>

      </Page>
    </Document>
  );
};

export default ActaPDF;